import checkout from "./Form";

const {
  formField: {
    full_name,
    social_name,
    cpf,
    birth_date,
    document_number,
    issuing_body,
    document_uf,
    gender,
    document_type,
    pa_id,
    status,
    complement,
    issue_date,
    nationality,
    birth_city,
    birth_uf,
    mothers_name,
    fathers_name,
    email,
    phone,
    contact,
    cep,
    street,
    number,
    state,
    neighborhood,
    city,
    mailing_address,
    income,
    contact_type,
    private_description,
    reason_reprovation,
    account_number,
    situation_document,
    hiring_type,
    responsible_email,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [full_name.name]: "",
  [social_name.name]: "",
  [cpf.name]: "",
  [birth_date.name]: "",
  [document_number.name]: "",
  [issuing_body.name]: "",
  [pa_id.name]: "",
  [status.name]: "",
  [document_uf.name]: "",
  [issue_date.name]: "",
  [nationality.name]: "",
  [birth_city.name]: "",
  [birth_uf.name]: "",
  [mothers_name.name]: "",
  [fathers_name.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [contact.name]: "",
  [cep.name]: "",
  [street.name]: "",
  [number.name]: "",
  [state.name]: "",
  [neighborhood.name]: "",
  [city.name]: "",
  [mailing_address.name]: "",
  [income.name]: "R$ 0,00",
  [contact_type.name]: "",
  [gender.name]: "",
  [document_type.name]: "",
  [complement.name]: "",
  [private_description.name]: "",
  [reason_reprovation.name]: "",
  [account_number.name]: "",
  [situation_document.name]: "",
  [hiring_type.name]: "1",
  [responsible_email.name]: "",
};